type AccountInvitationPayload = {
  firstName?: string;
  lastName?: string;
  email?: string;
  roleId?: number;
};

export type GetAccountInvitationsResponse = {
  totalItems: number;
  items: AccountInvitation[];
  page?: number;
  perPage?: number;
  totalPages?: number;
};

export type CreateAccountInvitationPayload = {
  senderFirstName: string;
  senderLastName: string;
  senderEmail: string;
  emails?: string[];
  role?: string;
  invitations?: AccountInvitationPayload[]
};

export type AccountInvitation = {
  id: number;
  senderFirstName?: string;
  senderLastName?: string;
  senderEmail?: string;
  email: string;
  firstName?: string;
  lastName?: string;
  roleId?: number;
  expiry?: Date;
};

export const sortableAccountInvitationsColumns
  = ['senderFirstName', 'senderLastName', 'senderEmail', 'email', 'role'] as const;

export type SortableAccountInvitationColumns = typeof sortableAccountInvitationsColumns[number];